import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import moment from "moment";

dayjs.extend(utc);
dayjs.extend(timezone);

export class DatesUtils {
	static convertUtcToLocal(utcIsoStringDateTime: string): string {
		return dayjs(utcIsoStringDateTime).local().format("YYYY-MM-DD HH:mm:ss");
	}

	static convertTimestampToLocal(timestamp: number): string {
		return dayjs.unix(timestamp).local().format("YYYY-MM-DD HH:mm:ss");
	}

	static convertTimeStampToLocalDateTimeString(timeStamp: number) {
		//Convert timestamp to local datetime string

		// const localDateTimeString = new Date(timeStamp).toLocaleString();
		// return localDateTimeString;
		var myDate = new Date(timeStamp * 1000);
		return myDate.toLocaleString();
	}

	static convertFromTimezoneToUtc(localDateString: string, timeZone: string) {
		// Local date and time
		//const localDate = '2024-08-05 13:10:00';
		// Custom timezone string
		//const customTimezone = '(UTC-06:00) Guadalajara-Mexico City-Monterrey';

		// Extract the UTC offset part
		const utcOffset = timeZone.match(/\(UTC([+-]\d{2}:\d{2})\)/)![1];

		// Convert local date to UTC
		const utcDate = moment
			.tz(localDateString + utcOffset, "YYYY-MM-DD HH:mm:ssZ")
			.utc()
			.format();

		console.log(`UTC ISO String: ${utcDate}`);

		return utcDate;
	}

	static formatDate = (date: Date): string => {
		const pad = (n: number) => n.toString().padStart(2, "0");

		const year = date.getFullYear();
		const month = pad(date.getMonth() + 1);
		const day = pad(date.getDate());
		const hours = pad(date.getHours());
		const minutes = pad(date.getMinutes());
		const seconds = pad(date.getSeconds());

		return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	};
}
